import React from 'react';

import { faEllipsisVertical } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button as ShadcnButton } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SECONDARY_ACTIONS } from '../../../constants';
import { useConversations } from '../../../hooks';

const Dropdown = () => {
  const { isLoadingActive: isLoading } = useConversations();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <ShadcnButton
          aria-label="More Options"
          disabled={isLoading}
          size="icon"
          variant="ghost"
        >
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </ShadcnButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {SECONDARY_ACTIONS.map((action) => (
          <DropdownMenuItem key={action}>{action}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Dropdown;
